export default "__VITE_ASSET__yK$fDZO7__"